module.exports = __webpack_public_path__ + "img/delete.ecb64113.svg";